import React, { useEffect, useMemo, useRef, useState } from 'react'
import ApexCharts from 'react-apexcharts';
import { ReactComponent as Time } from "../../../../assets/images/recovery_dahboard/time.svg";
import { CallApi, CommonModal } from '../../../../Components/common/CommonFunctions';
import { ReactComponent as BarChart } from "../../../../assets/images/icon_svg/bar_chart.svg";
import { ReactComponent as PieChart } from "../../../../assets/images/icon_svg/pie_chart.svg";
import { ReactComponent as DataGrid } from "../../../../assets/images/icon_svg/data_grid.svg";
import TableGrid from "../../../../Components/common/TableGrid";
import { Table } from 'react-bootstrap';
import { useEditorState } from 'react-simple-wysiwyg';
import { toast } from 'react-toastify';
const RegionChartDetails = ({ data, onOpenFilter  }) => {
    const isMounted = useRef(false)
    const defaultKpiData = {
        discrepancies_segregation : [],
        discrepancies_time_frame : [],
        error_station_distribution : []
    }
    const [openPie, setOpenPie] = useState(false);
    const [kpiData, setKpiData] = useState(defaultKpiData)
    const dsCategories = data?.discrepancies_segregation?.map(i => i.name) || [];
    const dcaLabels = data?.error_station_distribution?.map(i => i.name) || [];
    const DRTFCategories = data?.discrepancies_time_frame?.map(i => i.name) || [];
    const errorStationData = useMemo(() => {
        return (kpiData?.error_station_distribution || []).map(row => ({
            ...row,
            total:
                (row.others || 0) +
                (row.DXB || 0) +
                (row.DWC || 0) +
                (row.unknown || 0),
        }));
    }, [kpiData]);

    const grandTotal = (kpiData?.error_station_distribution || []).reduce(
    (acc, row) => {
        acc.others += row.others || 0;
        acc.DXB += row.DXB || 0;
        acc.DWC += row.DWC || 0;
        acc.unknown += row.unknown || 0;
        acc.total +=
            (row.others || 0) +
            (row.DXB || 0) +
            (row.DWC || 0) +
            (row.unknown || 0);

        return acc;
    },
    { others: 0, DXB: 0, DWC: 0, unknown: 0, total: 0 }
);

    const dsOptions = {
        chart: {
            type: 'bar',
            height: 350,
            stacked: false,
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                borderRadius: 6,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top',
                },
            }
        },
        markers: {
            size: 4,
            strokeWidth: 2,
            // strokeColors: "#1D4ED8"
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            formatter: (val) => val,
            style: {
                fontSize: '12px',
                colors: ["#304758"]
            },
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: dsCategories,
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        yaxis: {
            title: {
                text: ''
            },
            min: 0,
            // max: 500,
            // tickAmount: 5,
            labels: {
                formatter: (val) => Math.round(val),
            },
        },
        fill: {
            opacity: 1,
            colors: ["#4F81BC", "#C0514D"]
        },
        tooltip: {
            y: {
                formatter: (val) => val + " units"
            }
        },
        legend: {
            show: true,
            position: "bottom",
            fontWeight: 700,
            markers: {
                shape: 'circle',
            }
        },
    };

    const dsSeries = [
        { name: "AT HUB", data: data?.discrepancies_segregation?.map(i => i.atHub) || [] },
        { name: "AT OUTSTATION", data: data?.discrepancies_segregation?.map(i => i.outstation) || [] },
    ];

    const dcaOptions = {
        chart: {
            type: "pie",
            height: 350,
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            pie: {
                dataLabels: {
                    offset: 50,
                    minAngleToShowLabel: 10,
                },
                expandOnClick: true,
            },
        },
        stroke: {
            show: true,
            width: 0,
            colors: ['transparent']
        },
        labels: dcaLabels,
        legend: {
            position: "right",
        },
        dataLabels: {
            enabled: false,
            // formatter: function (val) {
            //     return Math.round(val);
            // },
            // style: {
            //     fontSize: "12px",
            //     colors: ["#333"],
            // },
            // dropShadow: {
            //     enabled: false,
            // },
        },
        colors: [
            "#4F81BD",
            "#8064A2",
            "#9BBB59",
            "#C0504D",
        ],
    };

    const dcaSeries = data?.error_station_distribution?.map(i => i.count) || [];

    const DRTFOptions = {
        chart: {
            type: 'bar',
            height: 350,
            stacked: false,
            toolbar: {
                show: false
            },
            zoom: {
                enabled: false
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                borderRadius: 6,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'top',
                },
            }
        },
        markers: {
            size: 4,
            strokeWidth: 2,
            // strokeColors: "#1D4ED8"
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            formatter: (val) => val,
            style: {
                fontSize: '12px',
                colors: ["#304758"]
            },
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: DRTFCategories,
            labels: {
                style: {
                    fontSize: '12',
                    colors: ["#000"],
                    fontWeight: 600,
                }
            }
        },
        yaxis: {
            title: {
                text: ''
            },
            min: 0,
            // max: 500,
            // tickAmount: 5,
            labels: {
                formatter: (val) => Math.round(val),
            },
        },
        fill: {
            opacity: 1,
            colors: ["#4f81bd", "#c0504d", "#9bbb59", "#8064a2"]
        },
        tooltip: {
            y: {
                formatter: (val) => val + " units"
            }
        },
        legend: {
            show: true,
            position: "bottom",
            fontWeight: 700,
            markers: {
                shape: 'circle',
            }
        },
    };

    const DRTFSeries = [
        { name: "12hrs", data: data?.discrepancies_time_frame?.map(i => i.less_than_12hrs) || [] },
        { name: "24hrs", data: data?.discrepancies_time_frame?.map(i => i.hrs_12_24) || [] },
        { name: "48hrs", data: data?.discrepancies_time_frame?.map(i => i.hrs_24_48) || [] },
        { name: "More than 48hrs", data: data?.discrepancies_time_frame?.map(i => i.more_than_48hrs) || [] },
    ];

    const columns = [
        { label: "Type", field: "name", enableSearch: false, cls: 'tw-15' },
        { label: "OS ERROR", field: "others", enableSearch: false, cls: 'tw-20' },
        { label: "DXB ERROR", field: "DXB", enableSearch: false, cls: 'tw-20' },
        { label: "DWC ERROR", field: "DWC", enableSearch: false, clas: 'tw-20' },
        { label: "UNK ERROR", field: "unknown", enableSearch: false, cls: 'tw-20' },
        { label: "Total", field: "total", enableSearch: false }
    ]

    const pieData = []

    const openPieDetails = () => {
        setOpenPie(true)
    }

    const closePieDetails = () => {
        setOpenPie(false)
    }

    const viewKpiChartData = () =>{
           CallApi({
                    endPoint: '/v2/service-recovery/kpichart-viewdata',
                    onSuccess: (res) => {
                        if (res.data.response_code === 200) {
                            const resData = res.data.response_data;
                            setKpiData(resData)
                        } else {
                            toast.error(res.data.response_msg);
                        }
                    },
                    onError: (msg) => toast.error(msg)
                });
    }

    useEffect(()=>{
        if (isMounted.current) return;
        viewKpiChartData()
        isMounted.current = true;
    },[])

    return (
        <div>
            <div className='d-flex gap-3 mb-3'>
                <div className='global_roundbg tw-50'>
                    <div className='box_icon_text box_icon_text_two'>
                        <span className='border_icon'><BarChart /></span>
                        <div className='d-flex justify-content-between w-100 align-items-center'>
                            <h3>Discrepencis Segregation – Report At Hub & Network</h3>
                            <button className='fullscren_btn'><DataGrid className='me-2'/>View data</button>
                        </div>
                    </div>
                    <ApexCharts
                        options={dsOptions}
                        series={dsSeries}
                        type="bar"
                        height={318}
                    />

                </div>

                <div className='global_roundbg tw-50'>
                    <div className='box_icon_text box_icon_text_two'>
                        <span className='border_icon'><PieChart /></span>
                        <div className='d-flex justify-content-between w-100 align-items-center'>
                            <h3>Discrepencis Contributing Areas</h3>
                            <button onClick={openPieDetails} className='fullscren_btn'><DataGrid className='me-2'/>View Data</button>
                        </div>

                    </div>
                    <ApexCharts
                        options={dcaOptions}
                        series={dcaSeries}
                        type="pie"
                        height={318}
                    />

                </div>
            </div>
            <div className='global_roundbg tw-100'>
                <div className='box_icon_text box_icon_text_two'>
                    <span className='border_icon'><BarChart /></span>
                    <div className='d-flex justify-content-between w-100 align-items-center'>
                        <h3>Descrepencis Resolve Time Frame</h3>
                        <button className='fullscren_btn'><DataGrid className='me-2'/>View Data</button>
                    </div>

                </div>
                <ApexCharts
                    options={DRTFOptions}
                    series={DRTFSeries}
                    type="bar"
                    height={318}
                />

            </div>

            <CommonModal
                mSize={"lg"}
                show={openPie}
                onHide={closePieDetails}
                title={"Descrepencies Contributing Areas"}
                className='modal_bgw primary_modal'
            >
                <div>
                    <Table>
                        <thead>
                            <tr>
                                {columns.map((col)=>(
                                    <th>{col.label}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {errorStationData.map((row, index) => (
                                <tr key={index}>
                                    <td>{row.name}</td>
                                    <td>{row.others}</td>
                                    <td>{row.DXB}</td>
                                    <td>{row.DWC}</td>
                                    <td>{row.unknown}</td>
                                    <td>{row.total}</td>
                                </tr>
                            ))}
                            <tr >
                                <td>Total</td>
                                <td>{grandTotal.others}</td>
                                <td>{grandTotal.DXB}</td>
                                <td>{grandTotal.DWC}</td>
                                <td>{grandTotal.unknown}</td>
                                <td>{grandTotal.total}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </CommonModal>
        </div>
    )
}

export default RegionChartDetails